'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Space type fill colors list
//***********************************************************************************
//***********************************************************************************

export const space_type_colors = [
    '#ABD3DB',
    '#C2E6DF',
    '#D1EBD8',
    '#E5F5DC',
    '#FFFFE1',
    '#F2D0D9',
    '#F2F2F2',
    '#B8C6D9',
    '#8596A6',
    '#F2D9D0'
]

